import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import leftarrow from "../../Assets/Images/CreateBatch/Group27.png";
import rightarrow from "../../Assets/Images/CreateBatch/Group27(1).png";
import DatePicker from "react-datepicker";
import SearchCB from "../../Assets/Images/CreateRole/Search.png";
import "react-datepicker/dist/react-datepicker.css";
import format from "date-fns/format"; // Add this line
import DropDownCB from "./DropdownCB";
import { API_BASE_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import YellowSearch from "../../Assets/Images/CommanImages/searchyellow.png";
// import './customDatePicker.scss';
import "./CreateBatch.css";
const CreateBatch = (dataClient) => {
  // CommonJS
  const swal = require("sweetalert2");
  const [sliderValue, setSliderValue] = useState([65, 70]);
  const [singleValue, setSingleValue] = useState({ year: 2014, month: 11 });
  const handleSliderChange = (value) => {
    setSliderValue(value);
  };
  const [currentPage, setCurrentPage] = useState(1);
  // const itemsPerPage = 25;
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [selectedButton, setSelectedButton] = useState(25);
  const user_name = dataClient?.dataClient?.client_schema_name[6][0].user_name;
  const [assignedStudents, setAssignedStudents] = useState([]);
  const [secondTableStudentIds, setSecondTableStudentIds] = useState([]);
  const [studentTypeId, setStudentTypeId] = useState(null);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batchName, setBatchName] = useState("");
  const [courseOpted, setCourseOpted] = useState("");
  const [coachingMode, setCoachingMode] = useState("");
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [studentData, setStudentData] = useState([]);
  const [selectedClassObj, setSelectedClassObj] = useState(null);
  const [initialData, setInitialData] = useState([]);
  const [firstTableData, setFirstTableData] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [excludeAssigned, setExcludeAssigned] = useState(false);
  const [tentativeExamDate, setTentativeExamDate] = useState(new Date());
  // const [tentativeExamDate, setTentativeExamDate] = useState(new Date(2010, 0));
  const clientBranchId =
    dataClient.dataClient?.client_schema_name[6][0].client_branch_id;
  const clientId = dataClient.dataClient?.client_schema_name[6][0].client_id;
  // console.log("CB", clientBranchId, clientId);
  const [batchDescription, setBatchDescription] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const coachingModeOptions = [
    { id: "Online", label: "Online" },
    { id: "Classroom", label: "Classroom" },
    { id: "Hybrid", label: "Hybrid" },
  ];
  const classTypeAbbreviations = {
    Online: "OL",
    Classroom: "CL",
    Hybrid: "H",
  };
  const classTypeToId = {
    Online: 1,
    Classroom: 2,
    Hybrid: 3,
  };

  const handleStyle = {
    borderRadius: 0,
    backgroundColor: "#EFEFEF",
    border: "2px solid #999999",
    height: "28px",
    width: "20px",
    opacity: 1,
  };

  const trackStyle = {
    backgroundColor: "#D6D6D6",
    height: "20px",
    border: "1px solid #999999",
  };

  const railStyle = {
    borderRadius: 0, // Add this line
    backgroundColor: "#FFFFFF",
    height: "20px",
    border: "2px solid #999999",
  };
  const [firstSearchTerm, setFirstSearchTerm] = useState("");
  const [secondSearchTerm, setSecondSearchTerm] = useState("");

  // Define state variables for selected course and class IDs

  useEffect(() => {
    const fetchCourses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-courses/`
      );
      const data = await response.json();
      setCourses(data);
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchClasses = async () => {
      const response = await fetch(
        `${API_BASE_URL}/prism/api/v1/get-classes/`
      );
      const data = await response.json();
      setSelectedClass(data); // Save the entire class object in the state
    };

    fetchClasses();
  }, []);
  useEffect(() => {
    // Only fetch the student data if both the course and class are selected
    if (selectedCourseId && selectedClassObj && studentTypeId) {
      const fetchStudentData = async () => {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
        );
        let data = await response.json();

        data = mapEmptyBatchToNoBatch(data);

        setStudentData(data); // Save the student data in the state
      };

      fetchStudentData();
    }
  }, [selectedCourseId, selectedClassObj, studentTypeId]);

  const handleCourseSelection = (selectedCourseId) => {
    // Find the selected course object
    const selectedCourse = courses.find(
      (course) => course.course_id === selectedCourseId
    );

    // Set the selected course ID
    setSelectedCourseId(selectedCourse.course_id);

    // Set the selected course name
    setSelectedCourseName(selectedCourse.course_name);
  };

  const handleClassSelection = (selectedClassId) => {
    // Find the selected class object
    const selectedClassObj = selectedClass.find(
      (classObj) => classObj.class_id === selectedClassId
    );

    // Set the selected class object
    setSelectedClassObj(selectedClassObj);

    // Set the selected class name
    setSelectedClassName(selectedClassObj.class_name);
  };
  const unassignStudents = () => {
    const selectedStudentsCopy = secondTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setFirstTableData((prevFirstTableData) => [
      ...prevFirstTableData,
      ...selectedStudentsCopy,
    ]);
    const newSecondTableData = secondTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the secondTableData state with the new array
    setSecondTableData(newSecondTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  useEffect(() => {
    const newBatchCode = `${selectedCourseName}-${selectedClassName}-${classTypeAbbreviations[coachingMode]}-${batchName}`;
    setBatchCode(newBatchCode);
  }, [selectedCourseName, selectedClassName, coachingMode, batchName]);

  const createBatch = async () => {
    console.log("batchName: ", batchName);
    console.log("coachingMode: ", coachingMode);
    console.log("selectedCourseId: ", selectedCourseId);
    console.log("selectedClassObj: ", selectedClassObj);
    console.log("type of student ", studentTypeId);
    if (
      !batchName ||
      !studentTypeId ||
      !coachingMode ||
      !selectedCourseId ||
      !selectedClassObj
    ) {
      Swal.fire({
        title: "Error",
        text: "Please fill all the required fields.",
        icon: "error",
        confirmButtonColor: "rgb(100 101 101)",
      });
      return;
    }

    const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/new-batch?client_id=${clientId}&client_br_id=${clientBranchId}&batch_name=${batchName}&batch_code=${selectedCourseName}-${selectedClassName}-${
      classTypeAbbreviations[coachingMode]
    }-${batchName}&batch_desc=${batchDescription}&coaching_mode_id=${
      classTypeToId[coachingMode]
    }&tentative_exam_dt=${format(
      tentativeExamDate,
      "yyyy-MM-dd"
    )} 13:09:58.000&course_id=${selectedCourseId}&class_id=${
      selectedClassObj.class_id
    }&user_name=${user_name}`;

    // Format the students data
    const studentsFormatted = secondTableData.map((student) => ({
      student_id: student.student_id,
    }));
    const hasAssignedStudents = secondTableData.some(
      (student) => student.batch_name !== null
    );

    const postBatch = async () => {
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(studentsFormatted), // Send the formatted students data in the body
        });
        if (response.ok) {
          Swal.fire({
            title: "Batch Created Successfully",
            icon: "success",
            timer: 2000, // 2 seconds
            confirmButtonColor: "#318682", // This will change the "OK" button color
          }).then(() => {
            setTimeout(function () {
              window.location.reload();
            }, 100);
          });
        }

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error(error);
        Swal.fire({
          title: "Error in submitting the form",
          text: "Please fill all the input fields",
          icon: "error",
          confirmButtonColor: "rgb(100 101 101)",
        });
      }
    };

    if (hasAssignedStudents) {
      Swal.fire({
        title: "Are you sure?",
        text: "There are students who are batch assigned. Are you sure you want to proceed?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonColor: "rgb(100 101 101)",
        cancelButtonColor: "#318682",
      }).then((result) => {
        if (result.isConfirmed) {
          postBatch(); // Call the function here
        }
      });
    } else {
      // If there are no assigned students, just post the students as they are
      postBatch();
    }
  };

  const handleStudentTypeSelection = (e) => {
    const selectedStudentTypeName = e.target.value;
    setStudentTypeId(classTypeToId[selectedStudentTypeName]);
  };

  // Update the useEffect hook
  useEffect(() => {
    if (selectedCourseId && selectedClassObj && studentTypeId) {
      const fetchStudentData = async () => {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/student-list-batch-assign/?course_id=${selectedCourseId}&class_id=${selectedClassObj.class_id}&student_type_id=${studentTypeId}&branch_id=${clientBranchId}`
        );
        let data = await response.json();

        data = mapEmptyBatchToNoBatch(data);

        setStudentData(data); // Save the student data in the state
      };

      fetchStudentData();
    }
  }, [selectedCourseId, selectedClassObj, studentTypeId]);

  const assignStudents = () => {
    const selectedStudentsCopy = firstTableData.filter((student) =>
      selectedStudentIds.includes(student.student_id)
    );

    setSecondTableData((prevSecondTableData) => [
      ...prevSecondTableData,
      ...selectedStudentsCopy,
    ]);
    const newFirstTableData = firstTableData.filter(
      (student) => !selectedStudentIds.includes(student.student_id)
    );

    // Update the firstTableData state with the new array
    setFirstTableData(newFirstTableData);

    // Reset the selectedStudentIds
    setSelectedStudentIds([]);
  };

  // In your render method, when a checkbox is clicked
  const handleCheckboxClick = (studentId) => {
    setSelectedStudentIds((prevSelectedStudentIds) => {
      if (prevSelectedStudentIds.includes(studentId)) {
        // If the student is already selected, unselect them
        return prevSelectedStudentIds.filter((id) => id !== studentId);
      } else {
        // If the student is not selected, select them
        return [...prevSelectedStudentIds, studentId];
      }
    });
  };

  const mapEmptyBatchToNoBatch = (studentData) => {
    return studentData.map((student) => ({
      ...student,
      batch_name: student.batch_name === "" ? "NoBatch" : student.batch_name,
    }));
  };

  useEffect(() => {
    // Clear the table first
    setFirstTableData([]);

    // Use setTimeout to allow for the table to clear before setting the new data
    setTimeout(() => {
      // If excludeAssigned is true, only include students where batch_name is null
      if (excludeAssigned) {
        setFirstTableData(
          studentData.filter((student) => student.batch_name === null)
        );
      } else {
        setFirstTableData(studentData);
      }
    }, 0); // setTimeout with 0 delay ensures the clear operation happens first
  }, [excludeAssigned, studentData]);

  const handleCancel = () => {
    Swal.fire({
      title: "Are you sure you want to cancel?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: "rgb(100 101 101)",
      cancelButtonColor: "#318682",
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire("Cancelled", "Your changes have been cancelled.", "success");
        window.location.reload();
      }
    });
  };

  // const handleCancel = () => {
  //   setSliderValue([70, 78]);
  //   setSingleValue({ year: 2014, month: 11 });
  //   setCurrentPage(1);
  //   setAssignedStudents([]);
  //   setCourses([]);
  //   setBatchName("");
  //   setCourseOpted("");
  //   setCoachingMode("");
  //   setSelectedClass([]);
  //   setSelectedClassName("");
  //   setSelectedCourseId(null);
  //   setStudentData([]);
  //   setSelectedClassObj(null);
  //   setInitialData([]);
  //   setFirstTableData([]);
  //   setSecondTableData([]);
  //   setExcludeAssigned(false);
  //   setTentativeExamDate(new Date());
  //   setBatchDescription("");
  //   setBatchCode("");
  //   setSelectedCourseName("");
  // };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div className="container-UP" style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <p className="title-cb">Create Batch</p>
          <div className="mb-2-UP">
            <button className="cr-cancel-btn me-cs4" onClick={handleCancel}>
              CANCEL
            </button>
            <button className="cr-create-btn" onClick={createBatch}>
              SAVE
            </button>
          </div>
        </div>
        <hr
          style={{
            color: "black",
            backgroundColor: "black",
            marginTop: "5px",
          }}
        />
      </div>

      <div className="container-cs-fluid ms-cs3 mt-cs3">
        <div className="card-cs1 card-border-CR">
          <div className="basic-info-color  transparent-margin-left transparent-margin-all ">
            BASIC INFORMATION
          </div>
          <div className="row-cs grey-div-cs">
            <div className="col-cs">
              <div className="div mt-cs2 ms-cs2 grey-color-font">
                Batch Name <span style={{ color: "red" }}>*</span>
              </div>

              <div className=" mb-cs3 mt-cs2 ms-cs2 input-field-cs-2 ">
                <input
                  type="text"
                  className="form-control input-field-cs "
                  style={{ padding: "5px", outline: "none" }}
                  aria-label="Sizing example input "
                  aria-describedby="inputGroup-sizing-default"
                  onChange={(e) => setBatchName(e.target.value)}
                />
              </div>
              <div className="div ms-cs2 mt-cs2 grey-color-font">Batch ID </div>
              <div className="input-group mb-cs3 mt-cs2 ms-cs2">
                <input
                  type="text"
                  className="form-control input-field-cs-disabled-2 disabled-cs "
                  aria-label="Sizing example input "
                  aria-describedby="inputGroup-sizing-default"
                  disabled
                  value=""
                />
              </div>
              {/* <DropDownCB
                label="Batch ID"
                selected={""} // Empty string or null if you don't have a selected something yet
                setSelected={() => {}} // Empty function if you don't have a function to set the selected something yet
                options={[]} // Empty array for options
                style={{ marginLeft: "7px", width: "85%" }} // Add a margin to the left
              /> */}
            </div>
            <div className="col-cs">
              <div className="div mt-cs2 grey-color-font">Batch Code </div>
              <div className="input-group mb-cs3 mt-cs2">
                <input
                  type="text"
                  style={{ padding: "5px" }}
                  className="form-control input-field-cs-disabled disabled-cs "
                  aria-label="Sizing example input "
                  aria-describedby="inputGroup-sizing-default"
                  disabled
                  value={batchCode}
                />
              </div>
              <DropDownCB
                label="Batch Coaching Mode"
                style={{ width: "85%" }}
                selected={coachingMode}
                setSelected={setCoachingMode}
                options={coachingModeOptions}
              />
            </div>

            <div className="col-cs">
              <div className="div mt-cs2 grey-color-font">
                Description <span style={{ color: "red" }}>*</span>
              </div>
              <div className="input-groupmb-cs3 mt-cs2">
                <input
                  type="text"
                  className="form-control input-field-cs"
                  style={{ padding: "5px", outline: "none" }}
                  aria-div="Sizing example input"
                  aria-describedby="inputGroup-sizing-default"
                  onChange={(e) => setBatchDescription(e.target.value)}
                />
              </div>

              <div className="div mt-cs3 grey-color-font">
                Tentative Exam Date <span style={{ color: "red" }}>*</span>
              </div>
              <div style={{ width: "100%" }}>
                {/* <DatePicker
                  selected={tentativeExamDate}
                  onChange={(date) => setTentativeExamDate(date)}
                  dateFormat="yyyy/MM"
                  showMonthYearPicker
                  className="date-CB customDatePickerWidth" // Add the new class here
                  style={{ width: "100%" }}
                /> */}
                {/* <input className="date-CB" type="month" id="birthdaytime" name="birthdaytime" value="2010-01"></input> */}
                <input
                  className="date-CB"
                  type="month"
                  id="birthdaytime"
                  name="birthdaytime"
                ></input>
              </div>
            </div>
          </div>
        </div>

        <div className="card-cs1 grey-div-cs mt-cs4 card-border-CR">
          <div className="basic-info-color transparent-margin-left grey-color-font transparent-margin-all">
            ASSIGN STUDENT
          </div>
          <div>
            <div className="row-cs">
              <div className="col-cs">
                {" "}
                <DropDownCB
                  label="Courses"
                  style={{ marginLeft: "7px", width: "85%", marginTop: "5px" }}
                  selected={selectedCourseId}
                  setSelected={handleCourseSelection} // Use handleCourseSelection here
                  options={courses.map((course) => ({
                    id: course.course_id,
                    label: course.course_name,
                  }))}
                />
              </div>

              <div className="col-cs">
                {" "}
                <DropDownCB
                  label="Class"
                  style={{ marginTop: "5px", width: "85%" }}
                  selected={selectedClassObj ? selectedClassObj.class_id : ""}
                  setSelected={handleClassSelection} // Use handleClassSelection here
                  options={selectedClass.map((classObj) => ({
                    id: classObj.class_id,
                    label: classObj.class_name,
                  }))}
                />
              </div>
              <div className="col-cs">
                {" "}
                <DropDownCB
                  label="Class Type of Student"
                  style={{ width: "85%", marginTop: "5px" }}
                  selected={studentTypeId}
                  setSelected={setStudentTypeId}
                  options={[
                    { id: 1, label: "Online" },
                    { id: 2, label: "Classroom" },
                    { id: 3, label: "Both" },
                  ]}
                />
              </div>
            </div>

            <div className="row-cs ">
              <div className="col-cs-uni-7 ms-cs2-2 grey-color-font">
                {" "}
                <div className="percentile-div-cs ms-cs3 ">
                  <div className="mt-cs3-uni mb-cs2 grey-color-font">
                    Percentile: [{sliderValue[0]} - {sliderValue[1]}]
                  </div>
                  <Slider
                    className="mb-cs5 mt-cs3-uni"
                    range
                    allowCross={false}
                    value={sliderValue}
                    onChange={handleSliderChange}
                    handleStyle={[handleStyle, handleStyle]} // apply the style to both handles
                    trackStyle={[trackStyle, trackStyle]} // apply the style to both tracks
                    railStyle={railStyle} // apply the style to the rail
                  />
                </div>
              </div>
              <div className="col-cs">
                <DropDownCB
                  label="Mentor"
                  // style={{
                  //   marginLeft: "86px",
                  //   width: "78.7  %",
                  //   marginTop: "0.5rem",
                  // }}
                  // Add this line
                  style={{ width: "85%", marginTop: "5px" }}
                  selected={""} // Empty string or null if you don't have a selected mentor yet
                  setSelected={() => {}} // Empt  y function if you don't have a function to set the selected mentor yet
                  options={[]} // Empty array for options
                />
              </div>
            </div>
          </div>

          <hr className="dotted-hr ms-cs2 mb-cs2 " />
          {/* first table   */}
          <div className="row-cs">
            <div className="col-cs grey-color-font">
              <div class="form-check transparent-margin-all">
                <input
                  class="form-check-input ms-cs3"
                  type="checkbox"
                  value=""
                  id="flexCheckChecked"
                  checked={excludeAssigned}
                  onChange={() => setExcludeAssigned(!excludeAssigned)}
                />
                <label
                  class="form-check-label mb-cs2 ms-cs2"
                  for="flexCheckChecked"
                >
                  Exclude students with assigned batch
                </label>
              </div>
              {/*  */}
              <div className="div-contains-search-cvb">
                <input
                  className="input-search-cvb"
                  type="text"
                  onChange={(e) =>
                    setFirstSearchTerm(e.target.value.toLowerCase())
                  }
                />

                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb" alt="" />
                </button>
                {/*  */}
              </div>
              <table className="table-CBV2-1">
                <tr style={{ border: "1px solid #999", height: "30px" }}>
                  {["Name", "Roll. No.", "Batch", "Type", "Mentor"].map(
                    (header) => (
                      <th style={{ border: "none", font: "18px" }}>{header}</th>
                    )
                  )}
                </tr>
                {firstTableData
                  // .filter(
                  //   (student) =>
                  //     !excludeAssigned ||
                  //     (student.batch_name !== "" &&
                  //       student.full_name
                  //         .toLowerCase()
                  //         .includes(firstSearchTerm))
                  // )
                  .filter(
                    (student) =>
                      (!excludeAssigned || student.batch_name !== "") &&
                      student.full_name.toLowerCase().includes(firstSearchTerm)
                  )
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((student, index) => (
                    <tr
                      style={{ border: "1px solid #999" }}
                      key={student.student_id}
                    >
                      <td>
                        <input
                          type="checkbox"
                          style={{ margin: "5px" }}
                          checked={selectedStudentIds.includes(
                            student.student_id
                          )}
                          onChange={() =>
                            handleCheckboxClick(student.student_id)
                          }
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.full_name}
                        >
                          {student.full_name}
                        </span>
                      </td>

                      <td>{student.roll_number}</td>
                      <td>
                        {student.batch_name ? student.batch_name : "NoBatch"}
                      </td>
                      <td>
                        <div className="center-items-cbv2">
                          <div
                            className={
                              student.class_type_id === 1
                                ? "rounded-rectangle-CBV2"
                                : student.class_type_id === 2
                                ? "rounded-rectangle-2-CBV2"
                                : ""
                            }
                          ></div>
                        </div>
                      </td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            width: "120px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.mentor_name}
                        >
                          {student.mentor_name}
                        </span>
                      </td>
                    </tr>
                  ))}
              </table>
              {/* first table */}
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  {firstTableData.length > 0 && (
                    <>
                      <p className="mt-cs1 ms-cs3 grey-color-font">
                        {selectedStudentIds.length} of {itemsPerPage} selected.
                      </p>
                      <p className="mt-cs2 mb-cs2 ms-cs3 grey-color-font">
                        Change table size :
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 25 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(25);
                            setSelectedButton(25);
                          }}
                        >
                          25
                        </button>
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 50 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(50);
                            setSelectedButton(50);
                          }}
                        >
                          50
                        </button>
                        <span>...</span>
                        <button
                          className={`table-size-change-buttons ${
                            selectedButton === 100 ? "selected" : ""
                          }`}
                          onClick={() => {
                            setItemsPerPage(100);
                            setSelectedButton(100);
                          }}
                        >
                          100
                        </button>
                      </p>
                    </>
                  )}
                </div>
                <div className="col-cs">
                  <div class="pagination-cs ">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination"
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a href="#" onClick={() => setCurrentPage(currentPage - 1)}>
                      {"<"} {/* Previous page */}
                    </a>
                    {Array(Math.ceil(studentData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a href="#" onClick={() => setCurrentPage(currentPage + 1)}>
                      {">"} {/* Next page */}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(studentData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-cs1">
              <button
                type="button"
                className="arrow-button-cs"
                onClick={assignStudents}
              >
                <p>
                  <i class="arrow right "></i>
                  <i class="arrow right margin-arrow-cs"></i>
                </p>
              </button>

              <button
                type="button"
                className="arrow-button-cs mt-cs4"
                onClick={unassignStudents}
              >
                <p>
                  <i class="arrow left margin-arrow-cs-2"></i>
                  <i class="arrow left "></i>
                </p>
              </button>
            </div>

            {/* second row  */}

            <div className="col-cs" style={{ marginRight: "10px" }}>
              <div class="form-check transparent-margin-all grey-color-font">
                <label class="form-check-label" for="flexCheckChecked">
                  Student Count : {secondTableData.length}
                </label>
              </div>

              {/*  */}

              {/* ////// */}
              <div className="div-contains-search-cvb-second">
                <input
                  className="input-search-cvb"
                  type="text"
                  onChange={(e) =>
                    setSecondSearchTerm(e.target.value.toLowerCase())
                  }
                />

                <button
                  style={{
                    width: "5%",
                    backgroundColor: "white",
                    border: "none",
                  }}
                >
                  <img src={YellowSearch} className="search-cvb" alt="" />
                </button>
              </div>
              <table className="table-CBV2-2 color424342">
                <tr style={{ border: "1px solid #999", height: "30px" }}>
                  {["Name", "Roll No.", "Batch", "Type", "Mentor"].map(
                    (header) => (
                      <th style={{ border: "none", font: "18px" }}>{header}</th>
                    )
                  )}
                </tr>
                {secondTableData
                  .filter((student) =>
                    student.full_name.toLowerCase().includes(secondSearchTerm)
                  )
                  .map((student, index) => (
                    <tr
                      style={{ border: "1px solid #999" }}
                      key={student.student_id}
                    >
                      <td>
                        <input
                          type="checkbox"
                          style={{ margin: "5px" }}
                          checked={selectedStudentIds.includes(
                            student.student_id
                          )}
                          onChange={() =>
                            handleCheckboxClick(student.student_id)
                          }
                        />
                        <span
                          style={{
                            display: "inline-block",
                            width: "100px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.full_name}
                        >
                          {student.full_name}
                        </span>
                      </td>
                      <td>{student.roll_number}</td>
                      <td>
                        {student.batch_name ? student.batch_name : "NoBatch"}
                      </td>
                      <td>
                        <div className="center-items-cbv2">
                          <div
                            className={
                              student.class_type_id === 1
                                ? "rounded-rectangle-CBV2"
                                : student.class_type_id === 2
                                ? "rounded-rectangle-2-CBV2"
                                : ""
                            }
                          ></div>
                        </div>
                      </td>
                      <td>
                        {" "}
                        <span
                          style={{
                            display: "inline-block",
                            width: "120px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={student.mentor_name}
                        >
                          {student.mentor_name}
                        </span>
                      </td>
                    </tr>
                  ))}
              </table>
              <div className="row-cs mt-cs3">
                <div className="col-cs">
                  {" "}
                  <p className="mt-cs1 ms-cs3 grey-color-font">
                    {selectedStudentIds.length} of {secondTableData.length}{" "}
                    selected.
                  </p>
                </div>
                <div className="col-cs">
                  <div class="pagination-cs-2">
                    <a
                      href="#"
                      className="leftarrow-rounded"
                      onClick={() => setCurrentPage(1)}
                    >
                      <img
                        className="leftarrow-pagination "
                        src={leftarrow}
                        alt=""
                      />
                    </a>
                    <a href="#" onClick={() => setCurrentPage(currentPage - 1)}>
                      {"<"} {/* Previous page */}
                    </a>
                    {Array(Math.ceil(secondTableData.length / itemsPerPage))
                      .fill()
                      .map((_, index) => (
                        <a
                          href="#"
                          className={index + 1 === currentPage ? "active" : ""}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </a>
                      ))}
                    <a href="#" onClick={() => setCurrentPage(currentPage + 1)}>
                      {">"} {/* Next page */}
                    </a>
                    <a
                      href="#"
                      className="rightarrow-rounded"
                      onClick={() =>
                        setCurrentPage(
                          Math.ceil(secondTableData.length / itemsPerPage)
                        )
                      }
                    >
                      <img
                        className="rightarrow-pagination"
                        src={rightarrow}
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* second row end  */}
          </div>
        </div>
      </div>

      {/* <div className="float-right-cs PBDI-CB">Powered By DSE Infotech</div> */}
    </div>
  );
};

export default CreateBatch;
